var riot = require('riot');
module.exports = riot.tag2('app', '<router routes="{routes}"></router>', '', '', function(opts) {
        this.routes = require('modules/constants').ROUTES;
});